<template>
  <v-container>
    <v-card-title class="themed-card-title">Explore Data</v-card-title>
    <model-group-tabs />
    <v-card-text>
      <v-row class="mt-6">
        <v-col cols="12" :md="graphColumns">
          <main-chart
            :patientData="patientData"
            :fewPatients="fewPatients"
            :highlightGroup="numHighlighted !== null"
            :requestError="requestError"
          ></main-chart>
        </v-col>
        <v-col cols="12" :md="graphColumns">
          <mean-chart
            :patientData="patientData"
            :fewPatients="fewPatients"
            :highlightGroup="numHighlighted !== null"
            :requestError="requestError"
          ></mean-chart>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <visualisation-options
            :measurements="numMeasurements"
            :patients="numPatients"
            :highlighted="numHighlighted"
            class="mt-5"
            @graphPositioningChanged="setGraphColumns($event)"
          ></visualisation-options>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <app-filters
            @filtersChanged="loadData($event)"
            :fewPatients="fewPatients"
            class="mt-5"
          ></app-filters>
        </v-col>
      </v-row>
    </v-card-text>
  </v-container>
</template>

<script>
import axios from "@/axios";

import MainChart from "./MainChart";
import MeanChart from "./MeanChart";
import AppFilters from "./Filters.vue";
import VisualisationOptions from "./VisualisationOptions";
import ModelGroupTabs from "./ModelGroupTabs";

export default {
  components: {
    MainChart,
    MeanChart,
    AppFilters,
    VisualisationOptions,
    ModelGroupTabs
  },
  data: () => ({
    patientData: [],
    numMeasurements: "-",
    numPatients: "-",
    numHighlighted: null,
    fewPatients: false,
    graphColumns: "6",
    requestError: false
  }),
  methods: {
    async loadData(filters) {
      try {
        // Remove previous data
        this.patientData = [];
        this.numMeasurements = "-";
        this.numPatients = "-";
        this.numHighlighted = null;
        this.fewPatients = false;
        this.requestError = false;

        // Get data from server
        let results = await axios.post("/filtered-patients", { filters });
        results = results.data;

        // If the array is empty or less than 2 set the variable and return
        if (results.length < 2) {
          this.fewPatients = true;
          return;
        }

        // Count number of patients and measurements
        this.numPatients = results.length.toString();
        let numMeasurements = results.map(x => x.assessments.length);
        this.numMeasurements = numMeasurements
          .reduce((accumulator, currentValue) => accumulator + currentValue)
          .toString();

        // Count highlighted
        if (filters.highlightGroup) {
          this.numHighlighted = results
            .filter(x => x.highlighted)
            .length.toString();
        }

        // Save the data
        this.patientData = results;
      } catch (e) {
        this.requestError = true;
      }
    },
    setGraphColumns(selection) {
      selection = selection.toString();
      if (selection === "0") {
        this.graphColumns = "6";
      } else {
        this.graphColumns = "12";
      }
    }
  }
};
</script>
